export const getIsActionEnabled = state =>
    !!(
        state.organisationUnits.selected &&
        state.orgUnitGroupSets.selected &&
        !state.reportData.loading
    )



// WEBPACK FOOTER //
// ./src/redux/selectors/orgUnitDistReport/getIsActionEnabled.js